import { concat, hash } from '@ember/helper';

import { t } from 'ember-intl';
import { modifier } from 'ember-modifier';

import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from './styles.module.css';

const tScope = 'record_detail.forms.a11y_report.';
const bem = getBem(styles);
const setWidth = modifier((element, [score, types]) => {
  const total = types.passed + types.warning + types.failed;
  const width = (100 / total) * score;

  element.style.setProperty('width', `${width}%`);

  return () => element.style.removeProperty('width');
});

export const ResultsOverview = <template>
  <table class={{(bem)}}>
    <thead>
      <tr class={{bem 'row'}}>
        <th class={{bem 'level'}}>{{t (concat tScope 'level')}}</th>
        <th class={{bem 'score'}}>{{t (concat tScope 'passed')}}</th>
        <th class={{bem 'score'}}>{{t (concat tScope 'warning')}}</th>
        <th class={{bem 'score'}}>{{t (concat tScope 'failed')}}</th>
      </tr>
    </thead>
    <tbody>
      {{#each-in @overview as |level types|}}
        <tr class={{bem 'row'}}>
          <td class={{bem 'level'}}>
            <div class={{bem 'bar'}}>
              {{#each-in types as |type score|}}
                <div
                  class={{bem 'segment' (hash type=type)}}
                  {{setWidth score types}}
                ></div>
              {{/each-in}}
              <div class={{bem 'label'}}>{{level}}</div>
            </div>
          </td>
          {{#each-in types as |type score|}}
            <td class={{bem 'score'}}>
              {{score}}
            </td>
          {{/each-in}}
        </tr>
      {{/each-in}}
    </tbody>
  </table>
</template>;
